export enum SMSVerificationStatus {
    undefined = 0,
    success = 1,
    failure = 2
}